import { post } from "services/httpClient";
import { getCookie, removeCookie, setCookie } from "./CookieHandler";
import { ApiUrls } from "./globalVariables";
import { dispatchHandler, useContextDispatch } from "services/context/MainContext";
import { toast } from "react-toastify";
import { useEffect } from "react";
import useFetch from "services/hooks/useFetch";
import { actionTypes } from "services/context/reducer";

//External prize handling
//When user logs in with qr params it means user scanned the code. We get the code, processing it then adding points to user

export default function GetExternalPrize({ children }) {

    const [{}, doCustomerFetch] = useFetch(ApiUrls.GetCustomerInfo, "get")
    const [{ response: res2, isLoading: load2, error: statusError }, doVerifyFetch] = useFetch(ApiUrls.VerifyCode, "post")

    const dispatch = useContextDispatch()
    const { GET_USERINFO } = actionTypes

    //handled the cookie like this specify when user in logs out state

    const prizeData = getCookie("prizeData")

    useEffect(() => {
        if(prizeData) {
            const code = {"Code": (prizeData.split("="))[1]}
            if(getCookie("loginData")) {
                setTimeout(() => doVerifyFetch(code, handleRefreshInfo), 1000)
            }
        }
    }, [])

    //showing error or success toasts and doing its logic
    useEffect(() => {
        if(load2) {
            if(statusError) {
                toast.error(JSON.parse(statusError.response.data.Message).Exception)
                removeCookie("prizeData")
            }
            if(res2) {
                toast.success(`${res2.Data.Message} امتیاز ثبت شده : ${res2.Data.Point}`)
                doCustomerFetch(null, handleRefreshInfo)
            }
        }
    }, [load2])

    const handleRefreshInfo = (res) => {
        dispatchHandler(dispatch, GET_USERINFO, {userInfo: res.Data})
        removeCookie("prizeData")
    }

    return (<div>{children}</div>)
}